import { render, staticRenderFns } from "./sidebar-checkout-booking.vue?vue&type=template&id=0d879ae2&"
import script from "./sidebar-checkout-booking.vue?vue&type=script&lang=js&"
export * from "./sidebar-checkout-booking.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-checkout-booking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports